import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { css } from 'styled-components';
import { Box } from '../Box';
import { createComponent } from '../utils';
var defaultColors = [
    '#2ecc71',
    '#3498db',
    '#8e44ad',
    '#e67e22',
    '#e74c3c',
    '#1abc9c',
    '#2c3e50',
];
var getInitials = function (name) {
    if (name === void 0) { name = ''; }
    return name
        .split(' ')
        .slice(0, 2)
        .map(function (w) { return w[0]; })
        .join('');
};
var AvatarContainer = createComponent({
    name: 'Avatar',
    as: Box,
    style: function (_a) {
        var size = _a.size, borderRadius = _a.borderRadius, color = _a.color, backgroundColor = _a.backgroundColor, src = _a.src, theme = _a.theme;
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", "px;\n    width: ", "px;\n    border-radius: ", ";\n    background: ", ";\n    color: ", ";\n    text-align: center;\n    line-height: ", "px;\n    font-size: ", "px;\n\n    ", ";\n  "], ["\n    height: ", "px;\n    width: ", "px;\n    border-radius: ", ";\n    background: ", ";\n    color: ", ";\n    text-align: center;\n    line-height: ", "px;\n    font-size: ", "px;\n\n    ",
            ";\n  "])), size, size, borderRadius, theme.colors[backgroundColor || ''] || backgroundColor, color, size, (size || 0) * 0.5, src && {
            backgroundImage: "url(" + src + ")",
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        });
    },
});
var Avatar = function (_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, src = _a.src, backgroundColor = _a.backgroundColor, _c = _a.size, size = _c === void 0 ? 25 : _c, _d = _a.borderRadius, borderRadius = _d === void 0 ? '100%' : _d, _e = _a.color, color = _e === void 0 ? 'white' : _e, props = __rest(_a, ["name", "src", "backgroundColor", "size", "borderRadius", "color"]);
    return (React.createElement(AvatarContainer, __assign({ size: size, borderRadius: borderRadius, color: color, src: src, backgroundColor: backgroundColor || defaultColors[name.length % defaultColors.length], "aria-label": name }, props), src ? null : getInitials(name)));
};
Avatar.defaultProps = {
    size: 25,
    borderRadius: '100%',
    color: 'white',
};
export default Avatar;
var templateObject_1;
//# sourceMappingURL=Avatar.js.map